import * as m from "@/paraglide/messages"
import type { PersonalityAspectId } from "./types"

export const PERSONALITY_ASPECT_ORDER: PersonalityAspectId[] = [
	"archetype",
	"big_five",
	"friendship",
	"humor",
]

export function getPersonalityAspectLabel(
	aspectId: PersonalityAspectId,
): string {
	switch (aspectId) {
		case "archetype":
			return m.personalityAspectArchetype()
		case "big_five":
			return m.personalityAspectBigFive()
		case "friendship":
			return m.personalityAspectFriendship()
		case "humor":
			return m.personalityAspectHumor()
	}
}

function isPersonalityAspectId(value: unknown): value is PersonalityAspectId {
	return (
		typeof value === "string" &&
		PERSONALITY_ASPECT_ORDER.includes(value as PersonalityAspectId)
	)
}

export function parsePersonalityAspectId(
	value: unknown,
): PersonalityAspectId | undefined
export function parsePersonalityAspectId(
	value: unknown,
	fallback: PersonalityAspectId,
): PersonalityAspectId
export function parsePersonalityAspectId(
	value: unknown,
	fallback?: PersonalityAspectId,
): PersonalityAspectId | undefined {
	if (isPersonalityAspectId(value)) return value
	return fallback
}
